import React from 'react';
import { GenerateId } from 'jss';
import { StylesProvider, ThemeProvider as MuiThemeProvider } from '@material-ui/core';
import { theme } from './theme';

const generateClassName: GenerateId | undefined =
  process.env.NODE_ENV === 'test' ? (r, s) => `${s?.options.classNamePrefix}-${r.key}` : undefined;

export const ThemeProvider: React.FC = ({ children }) => (
  <StylesProvider generateClassName={generateClassName}>
    <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
  </StylesProvider>
);
